angular
    .module('festzelt-os.documents.templates')
    .factory('deleteDocumentTemplate', [
        '$injector',
        ($injector) => new DeleteDocumentTemplateWorkflow($injector)
    ]);

class DeleteDocumentTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');

        this.level = 'archived-highlight';
        this.order = 10;
        this.title = this.translate.instant('general.verbs.permanent_delete');
        this.icon = 'trash-alt';
        this.key = 'delete-document-template';
    }

    action(documentTemplate, vm) {
        return this.alert
            .animatedAlert(
                this.translate.instant('documents.workflows.template-details.delete.ask-to-delete.title'),
                this.translate.instant('documents.workflows.template-details.delete.ask-to-delete.content', {
                    template_title: documentTemplate.title
                }),
                'attention',
                {
                    confirmButtonText: this.translate.instant('general.verbs.permanent_delete'),
                    cancelButtonText: this.translate.instant('general.buttons.cancel'),
                    wait: true
                })
            .then(() => {
                return this.api
                    .delete(`documents/templates/${documentTemplate.id}`)
                    .then(
                        () => {
                            this.alert.hide();
                            this.state.go('app.documents.templates.index');
                            return this.alert.success(
                                this.translate.instant('general.alerts.remove_success.title'),
                                this.translate.instant('general.alerts.remove_success.content')
                            );
                        }
                    )
                    .catch(err => this.alert.handle(err));
            })
            .catch(
                err => this.alert.handle(err)
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/workflows/details/delete-template.js